export const Work = {
    cat: 'work',
    articles: {
        vvet: {
            slug: '',
            name: 'Vimeo Subscription',
            business: 'Webstartup',
            tech: ['WordPress', 'PHP', 'jQuery', 'Vimeo API'],
            summary: 'Created a plugin integrating the Vimeo API for a video subscription service, improving usability for the client in adding and maintaining videos, and users in finding and using them.',
            body: () => null,
            link: null,
            images: null
        },
        capd: {
            slug: '',
            name: 'Product Visualiser',
            business: 'TheOnlineCo.',
            tech: ['WordPress', 'WooCommerce', 'PHP', 'jQuery'],
            summary: 'Reverse engineered and reworked product visualiser into a plugin for integration into WordPress.',
            body: () => null,
            link: 'https://www.capitaldesignworks.com.au/visualiser/',
            oldLink: 'https://web.archive.org/web/20200222084314/http://visualiser.capitaldesignworks.com.au/',
            images: ['capd-1', 'capd-2']
        },
        toco: {
            slug: '',
            name: 'Rebuild + Podcasts Plugin',
            business: 'TheOnlineCo.',
            tech: ['WordPress', 'PHP', 'jQuery'],
            summary: 'Rebuilt the site based on designs provided by the team and also built a simple podcast plugin to integrate into the theme.',
            body: () => null,
            link: 'https://theonlineco.net/podcast/',
            oldLink: null,
            images: ['toco-1', 'toco-2', 'toco-3']
        }
    }
};